const APP_ID = 'tbibss';
const APP_KEY_LOCAL = '666tbibss20240919';

const APP_KEY = 'spark';
// 线上环境
// const API_URL = 'https://ygbh.run/pyapi';
// const HTTP_URL = 'https://ygbh.run/';
// const ALI_OSS_PATH="/ygbh/";
// const PHP_API_URL = 'https://ygbh.run';
// 本地正式版数据
// const API_URL = 'http://127.0.0.1:1003/pyapi';
// const HTTP_URL = 'https://ygbh.run/';
// const ALI_OSS_PATH="/ygbh/";
// const PHP_API_URL = 'https://ygbh.run';


// 本地测试地址
// const API_URL = 'http://127.0.0.1:1003/pyapi';
// const HTTP_URL = 'http://ygbh.gamification.org.cn/';
// const ALI_OSS_PATH="/testygbh/";
// const PHP_API_URL = 'http://ygbh.gamification.org.cn';



// 线上测试
const API_URL = 'https://ygbh.gamification.org.cn/pyapi';
const HTTP_URL = 'https://ygbh.gamification.org.cn/';
const ALI_OSS_PATH="/testygbh/";
const PHP_API_URL = 'https://ygbh.gamification.org.cn';

const PointsRecargeRatio = 100;

export { API_URL, APP_ID, APP_KEY_LOCAL,PHP_API_URL,HTTP_URL,ALI_OSS_PATH,APP_KEY,PointsRecargeRatio};
